import { FormRule } from "antd";
import { t } from "i18next";

export const trimRequired = (message?: string): FormRule => ({
  required: true,
  validator: (_, value) => {
    if (typeof value !== "string" || value.trim() === "") {
      return Promise.reject(Error(message ?? t("Field required")));
    }
    return Promise.resolve();
  },
});
